<template>
  <base-popup ref="popupNotification">
    <template #icon>
      <svg
        width="32"
        height="28"
        viewBox="0 0 32 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.6088 0.340515C31.5277 0.953429 31.7758 2.19522 31.1629 3.11414L15.0873 27.2156L1.03726 12.1694C0.28339 11.362 0.326718 10.0965 1.13403 9.34259C1.94135 8.58872 3.20694 8.63205 3.9608 9.43937L14.5629 20.7932L27.8352 0.894583C28.4481 -0.024335 29.6899 -0.2724 30.6088 0.340515Z"
          fill="#F2F2F2"
        />
      </svg>
    </template>
    <template #content>
      {{ $t('bills.notifications.templates.deleted') }}
    </template>
  </base-popup>
</template>

<script>
import BasePopup from '@vue-app/components/base/popup/BasePopup.vue'
export default {
  name: 'BillDeletedNotification',
  components: { BasePopup },
  data() {
    return {
      timeoutHandler: null,
    }
  },
  methods: {
    show(timeoutSeconds = 2) {
      let _timeToShow = timeoutSeconds * 1000

      this.$refs.popupNotification.open()

      this.timeoutHandler = setTimeout(() => {
        this.$refs.popupNotification.close()
      }, _timeToShow)
    },
  },
  beforeUnmount() {
    if (this.timeoutHandler) {
      clearInterval(this.timeoutHandler)
    }
  },
}
</script>
